uniform vec3 uDepthColor;
uniform vec3 uSurfaceColor;
uniform float uColorOffset;
uniform float uColorMultiplier;

uniform bool uEnableLight;
uniform vec3 uLightColor;
uniform float uLightIntensity;
uniform float uLightSpecular;
uniform float uLightDecay;

varying float vElevation;
varying vec3 vNormal;
varying vec3 vPosition;

#include ../includes/pointLight.glsl

void main(){
  vec3 viewDirection = normalize(vPosition - cameraPosition);
  vec3 normal = normalize(vNormal); // Les normales sont interpolées donc on re-normalise

  // Base color
  float mixStrength = (vElevation + uColorOffset) * uColorMultiplier;
  mixStrength = smoothstep(0.0, 1.0, mixStrength);
  vec3 color = mix(uDepthColor, uSurfaceColor, mixStrength);

  // Light
  vec3 light = vec3(0.0);
  light += pointLight(
    uLightColor, // Color
    uLightIntensity,  // Intensity
    normal,
    vec3(0.0, 1.0, 0.0), // Position
    viewDirection,
    uLightSpecular, // Specular
    vPosition,
    uLightDecay // Decay
  );
  if (uEnableLight) {
    color *= light;
  }

  // Final color
  gl_FragColor = vec4(color, 1.0);
  #include <tonemapping_fragment>
  #include <colorspace_fragment>
}